import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'visitorLineAddonsFilter'
})
export class VisitorLineAddonsFilterPipe implements PipeTransform {

  transform(addons: any[], dispalayname: string): any[] {
    return addons?.filter(addon => addon?.displayName != dispalayname) || [];
  }
}
